import React, { useMemo } from "react";

import { Box, Icon, Paragraph, Title } from "@sicredi/react";
import "./styles.scss";
import { Link } from "#/components/Link";
import { ListItemProps } from "./listItem.config";

export const ListItem: React.FC<ListItemProps> = ({
  icon,
  title,
  description,
  to,
  disabled,
  external,
  onClick,
}) => {
  const linkClass = useMemo(() => {
    const disableClass = disabled ? "disabled-link" : "";
    return `no-decoration box-list ${disableClass}`;
  }, [disabled]);

  return (
    <Link
      to={to && !disabled ? to : "#"}
      onClick={!disabled && onClick ? onClick : undefined}
      className={linkClass}
      target={external ? "_blank" : undefined}
      data-testid="list-item"
    >
      <Box>
        {icon ? (
          <Icon
            appearance={disabled ? "disabled" : "primary"}
            size={24}
            name={icon}
          />
        ) : undefined}
        <div>
          {title ? (
            <Title appearance="primary" as="h4">
              {title}
            </Title>
          ) : undefined}
          <Paragraph>{description}</Paragraph>
        </div>
        <Icon
          appearance={disabled ? "disabled" : "primary"}
          size={24}
          name="chevron-right"
        />
      </Box>
    </Link>
  );
};
